import "./LandingQuote.css";

function LandingQuote() {
  return (
    <section className="landing-quote">
      <p className="landing-quote__text">
        “ Met ContinuMee heeft u doorlopend inzicht in de ervaring van uw klanten met uw dienstverlening”
      </p>
      <div className="landing-quote__person">
        <img src="/ava-wolter.png" alt="Wolter van Dam" className="landing-quote__avatar" />
        <div className="landing-quote__name">Wolter van Dam</div>
        <div className="landing-quote__role">Partner Kurtosis</div>
      </div>
    </section>
  );
}

export default LandingQuote;
